import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored time part object.
 */
export const storedTimePartSchema: SchemaDefinition = {
	Name: 'stored-time-part',
	Properties: {
		Hours: { Type: 'number' },
		Minutes: { Type: 'number' },
		Seconds: { Type: 'number' }
	}
}